import { useTranslation } from 'react-i18next';
import { useEffect, useState } from 'react';

import { OnboardingStyle } from '../../../public/onboarding/onboarding-style';
import useAssistance from '../../../../hooks/useAssistance/useAssistance';
import { AuthHeader, FormLayout } from '../../../../global-styles/layout';
import { Heading2Text, Subhead02Text } from '../../../../components/typography/typography';
import GoogleMaps from '../../../../components/google-maps/GoogleMaps';
import AlxButton from '../../../../components/alx-components/button';
import { ISelectCraneProps } from './select-crane-types';
import { SelectCraneStyle } from './select-crane-style';
import { selectCraneMapStyles } from './select-crane-map-style';

const SelectCrane: React.FC<ISelectCraneProps> = ({ assistanceInfo, coords, onNextStep }) => {
  const { t } = useTranslation(['common', 'auth']);
  const [selectedCrane, setSelectedCrane] = useState<string>();

  const { identifier, faultType, latitude, longitude } = assistanceInfo;
  const requestCraneBody = { identifier, faultType, latitude, longitude };
  const { requestCranes, queryClient } = useAssistance({ requestCraneBody });

  const { data } = requestCranes;

  const handleClosestCrane = () => {
    if (!data?.listadoGruas) return;
    const selected = data.listadoGruas[0]?.codigoGrua;
    /* TODO unsure if next line required,
     + if not, avoid previous and use the value directly on setQueryData
     */
    setSelectedCrane(selected);
    // automatically continue if used this option
    queryClient.setQueryData(['selectedCrane', identifier], selected);
    onNextStep();
  };

  useEffect(() => {
    if (data?.codigo) {
      if (data.codigo === '1' && data.listadoGruas && data.listadoGruas.length === 1) {
        queryClient.setQueryData(['selectedCrane', identifier], data.listadoGruas[0]?.codigoGrua);
        onNextStep();
      } else if (data.codigo === '0') {
        queryClient.setQueryData(['selectedCrane', identifier], '');
        onNextStep();
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  if (!data || data?.codigo !== '2') return <></>;

  return (
    <SelectCraneStyle>
      <OnboardingStyle>
        <div className="onboarding-top">
          <AuthHeader>
            <div className="auth-header-title">
              <Heading2Text as="h1" weight={600}>
                {t('auth:unregistered.select-crane.title')}
              </Heading2Text>
            </div>
            <div className="auth-header-text">
              <Subhead02Text>{t('auth:unregistered.select-crane.text')}</Subhead02Text>
            </div>
          </AuthHeader>
          <div className="select-crane-map m-24px">
            <GoogleMaps
              mapStyles={selectCraneMapStyles}
              coords={coords}
              zoom={12}
              craneLocations={data?.listadoGruas ?? undefined}
              onCraneClick={setSelectedCrane}
              defaultCrane={selectedCrane ?? undefined}
            />
          </div>
        </div>
        <div className="button-wrapper">
          <FormLayout>
            <AlxButton
              onClick={handleClosestCrane}
              disabled={!data?.listadoGruas || data?.listadoGruas?.length === 0}
              data-cy="closest-crane"
            >
              {t('auth:unregistered.select-crane.closest')}
            </AlxButton>
            <AlxButton
              className={'secondary'}
              onClick={() => {
                queryClient.setQueryData(['selectedCrane', identifier], selectedCrane);
                onNextStep();
              }}
              data-cy="login-submit"
              disabled={!selectedCrane && !!data?.listadoGruas}
            >
              {t('common:buttons.next')}
            </AlxButton>
          </FormLayout>
        </div>
      </OnboardingStyle>
    </SelectCraneStyle>
  );
};

export default SelectCrane;
